import Angular from "angular";
import Template from "./customer-item.html";

export default Angular.module('customer-item', [])
    .component('customerItem', {
        template: Template,
        bindings: {
            customer: '<',
            iconRight: '@'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/customer-item/customer-item.js